module.exports = __webpack_public_path__ + "7f94dbe95268b42e1dea06b806bbca88.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/vue-create-options.png
// module id = 278
// module chunks = 1